'use client'
import type React from 'react';
import { type ButtonProps, Button as NextUIButton } from "@heroui/react";
import type { ButtonThemeType, ColorsThemeType } from '@/constants/project-specific/theme/types';
import { cn } from '@/util/cn';

interface ThemeButtonProps extends ButtonProps {
    theme: ButtonThemeType;
    color?: ColorsThemeType;
    variant?: "flat" | "shadow" | "solid" | "bordered" | "light" | "faded" | "ghost";
    startContent?: React.ReactNode;
    endContent?: React.ReactNode;
    spinner?: React.ReactNode;
    spinnerPlacement?: "start" | "end" | undefined;
    text?: string;
    disabled?: boolean;
    isLoading?: boolean;
    size?: "sm" | "md" | "lg";
    className?: string;
    onPress?: () => void;
}

const ButtonThemed: React.FC<ThemeButtonProps> = ({
    theme,
    variant = "shadow",
    disabled = false,
    isLoading = false,
    color = "default",
    size = "md",
    className = "",
    startContent = null,
    endContent = null,
    spinner = null,
    spinnerPlacement = "start",
    onPress,
    children,
    ...props
}) => {
    const appliedVariant = theme.variant ?? variant;
    const appliedSize = theme.size ?? size;
    const appliedTextShadow = appliedSize === "sm" ? "[text-shadow:_1px_1px_0_rgb(0_0_0_/_0.5)]" : "[text-shadow:_1px_1px_0_rgb(0_0_0_/_0.7)]";
    const appliedClassName = cn(appliedTextShadow, theme.className) ?? cn(appliedTextShadow, className);
    const appliedColor = theme.color || color; // Assuming a default color
    const appliedStartContent = theme.startContent ?? startContent;
    const appliedEndContent = theme.endContent ?? endContent;
    const appliedSpinner = theme.spinner ?? spinner;
    const appliedSpinnerPlacement = theme.spinnerPlacement ?? spinnerPlacement;



    return (
        <NextUIButton
            variant={appliedVariant}
            color={appliedColor}
            startContent={appliedStartContent}
            endContent={appliedEndContent}
            spinner={appliedSpinner}
            spinnerPlacement={appliedSpinnerPlacement}
            disabled={disabled}
            isLoading={isLoading}
            size={appliedSize}
            className={appliedClassName}
            onPress={onPress ?? (() => { })}
            {...props}
        >
            {children}
        </NextUIButton>
    );
};

export default ButtonThemed;